var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestionlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700195,
    y: 0.200195,
    width: 14.9333,
    height: 14.9333,
    rx: 7.46667,
    fill: "#2957FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0239 3.85742C11.0239 4.34204 10.6309 4.73548 10.1458 4.73548C9.66067 4.73548 9.26775 4.34256 9.26775 3.85742H7.85742V11.7692L12.4337 7.17038V3.85742H11.0234H11.0239Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 7.19336V8.60368C4.38501 8.60368 4.77845 8.99661 4.77845 9.48174C4.77845 9.96688 4.38553 10.3598 3.90039 10.3598V11.7701H7.85832L7.0781 7.19387H3.90039V7.19336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionlogo);
export default __webpack_public_path__ + "static/media/Suggestionlogo.d68f1b72a74924b3edaf5fe84d9ffcdc.svg";
export { ForwardRef as ReactComponent };